import React, {forwardRef} from 'react';
import PropTypes from 'prop-types';

const Search = forwardRef(({searchValue, setSearchValue, setParams, setActivePage, setTooltip}, ref) => {
	const handleChange = (event) => {
		const value = event.target.value;
		if (!value) {
			setParams(prevParams => {
				return {...prevParams, q: '', p: 1};
			});
			setActivePage(1);
		}
		setSearchValue(value);
	}

	const handleSubmit = (event) => {
		event.preventDefault();
		if (!searchValue) return;
		setParams(prevParams => {
			return {...prevParams, q: searchValue, p: 1};
		});
		setActivePage(1);
	}
    
	return (
		<div className="single-collection-page__search-form-container" ref={ref}>
			<form className="single-collection-page__search-form" onSubmit={handleSubmit}>
				<label htmlFor='search' className='visually-hidden'>Search</label>
				<input id='search' className="single-collection-page__search-input" type='text' value={searchValue} onChange={handleChange} placeholder={setTooltip} />
				<button className="single-collection-page__search-button" type='submit' aria-label='search'></button>
			</form>
		</div>
	)
});

Search.displayName = 'Search';

export default Search;

Search.propTypes = {
	searchValue: PropTypes.string,
	setSearchValue: PropTypes.func,
	setParams: PropTypes.func,
	setActivePage: PropTypes.func,
	setTooltip: PropTypes.string,
}